<div class="form">
    <div class="body mb-25">
        <div class="supply-plan-confirm">
            <div>
                <label>
                    <input type="radio" name="isCommunity" [value]="0" (click)="setContractType(0, 0);" [ngModel]="setStartingContract" />Rhode Island Energy
                    @if (utilityRate!=null && utilityRate>0) {
                    &#64; {{utilityRate | currency:'USD':'symbol':'1.5-5'}}/kWh
                    }<br />
                    <span>Month to Month</span>
                </label>
            </div>
            @if (communityRate!=null && communityRate>0) {
            <div>
                <label>
                    <input type="radio" name="isCommunity" [value]="1" (click)="setContractType(1, 0);" [ngModel]="setStartingContract" />NextEra Energy &#64; {{communityRate | currency:'USD':'symbol':'1.5-5'}}/kWh<br />
                    <span>Month to Month</span>
                </label>
            </div>
            }
            @for (existingContract of existingContracts; track existingContract) {
            <div>
                <label>
                    <input type="radio" name="existingContractId" (click)="setContractType(-1, existingContract.id);" [value]="existingContract.id" [ngModel]="existingContractId" />{{existingContract.supplierName}} &#64; {{existingContract.price | currency:'USD':'symbol':'1.5-5'}}/kWh<br />
                    <span>{{existingContract.termFrom | date:'shortDate'}} to {{existingContract.termTo | date:'shortDate'}}</span>
                </label>
            </div>
            }
            <div><label><input type="radio" name="existingContractId" [value]="-1" (click)="setContractType(-1, -1);" [ngModel]="existingContractId" />Other supplier</label></div>
        </div>
        @if (existingContractId==-1) {
        <div>
            <input type="text" [class]="getClassesForInput('currentSupplierName', true, existingContract!.supplierName)" name="currentSupplierName" [(ngModel)]="existingContract!.supplierName" (input)="resetError('currentSupplierName')" placeholder="Supplier Name" maxlength="50" />
            @if (getVisibilityForLabel(existingContract!.supplierName)) {
            <div class="placeholder">Supplier Name</div>
            }
            <input type="text" [class]="getClassesForInput('currentSupplierPrice', true, (existingContract!.price==null)?null:''+existingContract!.price)" name="currentSupplierPrice" [(ngModel)]="existingContract!.price" (input)="resetError('currentSupplierPrice')"
                   (focus)="focusField('currentSupplierPrice')" (focusout)="focusOutField('currentSupplierPrice')" [placeholder]="(focusedField()=='currentSupplierPrice')?'0.00000':'Price $/kWh'" [allowNegativeNumbers]="false" mask="separator.5" thousandSeparator="" />
            @if (getVisibilityForLabel((existingContract!.price==null)?null:''+existingContract!.price)) {
            <div class="placeholder">Price $/kWh</div>
            }
            <input matInput [matDatepicker]="picker1" [formControl]="termFrom" (click)="picker1.open(); resetError('termFrom');" [class]="getClassesForInput('termFrom', true, (termFrom.value==null)?null:termFrom.value.toString())" [matDatepickerFilter]="boundInactiveDatesFilter" placeholder="Service Start, 1st meter read on or after">
            <mat-datepicker #picker1 startView="multi-year" (yearSelected)="chosenYearHandler($event, termFrom)" (monthSelected)="chosenMonthHandler($event, termFrom, 'termFrom', picker1)"></mat-datepicker>
            @if (getVisibilityForLabel((termFrom.value==null)?null:termFrom.value.toString())) {
            <div class="placeholder">Service Start, 1st meter read on or after</div>
            }
            <input matInput [matDatepicker]="picker2" [formControl]="termTo" (click)="picker2.open(); resetError('termTo');" [class]="getClassesForInput('termTo', true, (termTo.value==null)?null:termTo.value.toString())" [matDatepickerFilter]="boundInactiveDatesFilterTermTo" placeholder="Service End, 1st meter read on or after">
            <mat-datepicker #picker2 startView="multi-year" (yearSelected)="chosenYearHandler($event, termTo)" (monthSelected)="chosenMonthHandler($event, termTo, 'termTo', picker2)">
            </mat-datepicker>
            @if (getVisibilityForLabel((termTo.value==null)?null:termTo.value.toString())) {
            <div class="placeholder">Service End, 1st meter read on or after</div>
            }
        </div>
        }
        @if (this.errorY().showError()) {
        <div class="error-block">{{errorY().error}}</div>
        }
    </div>
    <div class="block-buttons full-width under-card mb-20">
        <button type="button" (click)="cancel()">Cancel</button>
        <button type="button" class="highlighted-button" appOneClick (click)="nextStep()">Submit</button>
    </div>
</div>